import React from 'react';
import PropTypes from 'prop-types';

const QuickTip = ({ ariaLabel, children }) => {
  return (
    <aside className="quick-tips" aria-label={ariaLabel}>
      <div className="quick-tips__tail" />
      <div className="quick-tips__content">
        <div className="quick-tips__content__header">
          Quick Pro Tip
        </div>
        <div className="quick-tips__content__body">
          {children}
        </div>
      </div>
    </aside>
  );
};

QuickTip.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default QuickTip;
